export default __webpack_public_path__ + "static/media/family_friendly.ea5bf21b.svg";